import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { UpdatePIList, GetPatientInviteLogs, } from '../../../redux/v2/patient-invite/actions';

import CustomTable from '../../../common/CustomTable';



function PatientEmailLogs(props) {
    const { screenSize } = props;
    const { account } = props.User;
    const { list, count } = props.PatientInvite?.patientInviteLogs;

    const compress = screenSize == "s" || screenSize == "s2";

    return (
        <div className="patient-list">

            <div>
                <CustomTable
                    id="pi-c-list"
                    className={compress ? "pi-cl-compress" : ""}
                    title=""
                    description=""
                    store={props.PatientInvite?.patientInviteLogs}
                    table={{
                        headers: [
                            { title: "PATIENT NAME", },
                            { title: "EVENT", },
                            { title: "DATE", },
                        ],
                        body: (item, i) => {
                            let tempEvent = null, tempDate = null;
                            if (item?.plan_code && (item?.plan_code?.toLowerCase()?.includes("annual") || item?.plan_code?.toLowerCase()?.includes("monthly"))) {
                                tempEvent = "Subscription Started";
                                tempDate = item?.start_date;
                            } else if (item?.plan_code && (!item?.plan_code?.toLowerCase()?.includes("annual") && !item?.plan_code?.toLowerCase()?.includes("monthly"))) {
                                tempEvent = "Trial Started";
                                tempDate = item?.date_registered;
                            } else if (!item?.patient_indi_id) {
                                tempEvent = "Email Sent";
                                tempDate = item?.date_sent;
                            }

                            return (
                                <tr className={`pi-c-l ${(i + 1) % 2 === 0 ? "" : "tr-even"}`}>
                                    <td>
                                        <div>
                                            <h6>
                                                {`${item?.first_name} ${item?.last_name}`}
                                            </h6>
                                        </div>
                                    </td>

                                    <td>
                                        <div>
                                            <h6>{tempEvent}</h6>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <h6>{moment(tempDate).format("YY-MM-DD:HH:MM")}</h6>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                    }}
                    actions={{
                        getDependency: { value: account?.user?.id, key: "sender" },
                        get: (page, count, filter, sort) => {
                            props?.GetPatientInviteLogs(page, count, filter, sort);
                        },
                        filters: [
                            {
                                label: "Date:",
                                key: "sent_date",
                                options: [
                                    { label: 'Last 7 Days', value: 7 },
                                    { label: 'Last 14 Days', value: 14 },
                                    { label: 'Last 30 Days', value: 30 },
                                    { label: 'All Time', value: 0 },
                                ],
                            },
                            {
                                label: "Type:",
                                key: "event_type",
                                options: [
                                    { label: 'All', value: 0 },
                                    { label: 'Email Sent', value: 1 },
                                    { label: 'Trial Started', value: 2 },
                                    { label: 'Subscription Started', value: 3 },
                                ],
                            }
                        ],
                        emptyTable: props?.UpdatePIList,
                    }}
                />
            </div>
        </div >
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    PatientInvite: state.PatientInvite,
});

export default connect(mapStateToProps, {
    UpdatePIList,
    GetPatientInviteLogs,

})(PatientEmailLogs);
